export default __webpack_public_path__ + "static/media/info-yellow.d6417e36.svg";